import React from 'react';
import Badge from 'src/components/Badge';
import { AlertSeverity as Status } from '../types';

type StatusMapItem = {
  color?: 'error' | 'warning';
  label: string;
};

type Props = {
  value?: string;
};

function AlertSeverity({ value }: Props) {
  const statusMap: Record<Status, StatusMapItem> = {
    [Status.Critical]: { color: 'error', label: Status.Critical },
    [Status.Minor]: { color: 'warning', label: Status.Minor },
  };

  const statusKey =
    value && statusMap[value as Status] ? (value as Status) : Status.Minor;

  return (
    <>
      <Badge {...statusMap[statusKey]} />
    </>
  );
}

export default AlertSeverity;
